// src/firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth"; 
import { getMessaging, isSupported } from "firebase/messaging";
// ▼ 追加: App Check 用のモジュールをインポート
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

// あなたのFirebaseプロジェクト設定
const firebaseConfig = {
  apiKey: "AIzaSyCYFxacFKNAlTBuTnZGeBeL7ynWx5WvOnM",
  authDomain: "revengersblack.firebaseapp.com",
  projectId: "revengersblack",
  storageBucket: "revengersblack.firebasestorage.app",
  messagingSenderId: "799744966490",
  appId: "1:799744966490:web:b38ac14f887bbbcb343d63"
};

const app = initializeApp(firebaseConfig);

// ⬇️⬇️⬇️ App Check（現在は監視モード）⬇️⬇️⬇️
if (typeof window !== "undefined") {
  // ※ローカル環境(localhost)でテストする時だけ、以下のコメントアウトを外してください
  // window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;

  // ★ 初期化に失敗してもアプリ本体は動作させる。
  //   ここは firebase.js のトップレベルなので、例外を投げると
  //   App.js ごと読み込みに失敗し、全員の画面が白くなる。
  //   サイトキーの不備、reCAPTCHAスクリプトの読み込み失敗、
  //   LINEアプリ内ブラウザの制約など、失敗しうる要因は複数ある。
  //   監視モードのうちは、通らなくても実害はない。
  try {
    initializeAppCheck(app, {
      // Firebaseコンソールで登録した reCAPTCHA Enterprise のサイトキー
      provider: new ReCaptchaEnterpriseProvider('6Le1fWotAAAAADBgvWQ8yR3fO1srFW9LK42y5IyV'),
      isTokenAutoRefreshEnabled: true // トークンの自動更新
    });
  } catch (e) {
    console.warn('App Check の初期化をスキップしました:', e?.message || e);
  }
}
// ⬆️⬆️⬆️ ここまで ⬆️⬆️⬆️

const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider(); 

// スマホ等で画面が真っ白になるのを防ぐ安全装置
let messaging = null;
if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) {
      messaging = getMessaging(app);
    }
  }).catch((err) => console.log("通知非対応ブラウザです", err));
}

export { db, auth, messaging, googleProvider };